<template>
<!-- プロジェクト登録画面 -->
<CCard>
  <CCardHeader><strong>プロジェクト登録</strong></CCardHeader>
  <CCardBody>
    <p><span class="asterisk">*</span>が付いている項目は必須入力項目です</p>
    <hr>
    <ValidationObserver ref="obs" v-slot="ObserverProps">
      <CRow v-if="message.length">
        <ul>
          <li style="color: red;" v-for="error in message" :key="error">{{ error }}</li>
        </ul>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>顧客会社名<span class="asterisk">*</span></label>
          <ValidationProvider name='顧客会社名' rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="company_id">
              <option disabled value="">選択してください</option>
              <option v-for="option in options1" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='プロジェクト名' rules="required" v-slot="ProviderProps">
            <label>プロジェクト名<span class="asterisk">*</span></label>
            <CInput v-model="project_name" maxlength="30"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <label>自社管理者<span class="asterisk">*</span></label>
          <ValidationProvider name='自社管理者' rules="select" v-slot="ProviderProps">
            <select class="custom-select" v-model="own_staff_id">
              <option disabled value="">選択してください</option>
              <option v-for="option in options2" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='顧客会社担当者' v-slot="ProviderProps">
            <label>顧客会社担当者</label>
            <CInput v-model="staff_name" maxlength="20"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='関連会社' v-slot="ProviderProps">
            <CInput label="関連会社" v-model="related" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='その他関連' v-slot="ProviderProps">
            <CInput label="その他関連" v-model="otherRelated" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
    <hr>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='始業時刻' rules="required" v-slot="ProviderProps">
            <label>始業時刻<span class="asterisk">*</span></label>
            <CInput type="time" v-model="start_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='終業時刻' rules="required" v-slot="ProviderProps">
            <label>終業時刻<span class="asterisk">*</span></label>
            <CInput type="time" v-model="end_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='休憩開始時間' rules="required" v-slot="ProviderProps">
            <label>休憩開始時間<span class="asterisk">*</span></label>
            <CInput type="time" v-model="break_start_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='休憩終了時間' rules="required" v-slot="ProviderProps">
            <label>休憩終了時間<span class="asterisk">*</span></label>
            <CInput type="time" v-model="break_end_time" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='契約形態' rules="required" v-slot="ProviderProps">
            <label>契約形態<span class="asterisk">*</span></label>
            <CInput v-model="contract"/>
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間' rules="required|base_time" v-slot="ProviderProps">
            <label>基準時間(表示用)<span class="asterisk">*</span>
            </label>
            <CInput append="H" v-model="baseTime" placeholder="(例)150-200,無し等" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間(下限)' rules="num|base_time_min" v-slot="ProviderProps">
            <label>基準時間(下限)</label>
            <CInput append="H" v-model="baseTimeMin" maxlength="3" 
              @beforeinput.native="digitsOnly('baseTimeMin', $event)"
              @input.native="sanitizeDigits('baseTimeMin')"
              placeholder="(例)140" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="2">
          <ValidationProvider name='基準時間(上限)' rules="num|base_time_max" v-slot="ProviderProps">
            <label>基準時間(上限)</label>
            <CInput append="H" v-model="baseTimeMax" maxlength="3" 
              @beforeinput.native="digitsOnly('baseTimeMax', $event)"
              @input.native="sanitizeDigits('baseTimeMax')"
              placeholder="(例)180" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="4">
          <ValidationProvider name='その他契約事項' v-slot="ProviderProps">
            <CInput label="その他契約事項" v-model="otherContract" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <hr>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='開発言語' rules="required" v-slot="ProviderProps">
            <label>開発言語<span class="asterisk">*</span></label>
            <CInput v-model="language" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="3">
          <ValidationProvider name='その他必要技術' v-slot="ProviderProps">
            <CInput label="その他必要技術" v-model="otherTech" />
            <p class="error">
              <font color="red">{{ ProviderProps.errors[0] }}</font>
            </p>
          </ValidationProvider>
        </CCol>
      </CRow>
      <br>
      <CRow class="mt-3 align-items-center">
        <!-- 左寄せ：戻る -->
        <CCol class="text-start">
          <button class="btn btn-info" @click="valueCheck">戻る</button>
        </CCol>
        <CCol class="text-center">
          <button class="btn btn-info" v-on:click="openModal" :disabled="ObserverProps.invalid" type="button">確認</button>
          <!-- 登録確認モーダルコンポーネント呼出 -->
          <ProjectRegisterModal 
            :draggable="true" 
            :resizable="true" 
            :project="project_name" 
            :start="start_time" 
            :end="end_time"
            :restStart="break_start_time" 
            :restEnd="break_end_time" 
            :company="company_name" 
            :staff="staff_name" 
            :own_staff="own_staff_name" 
            :authorized="authorized"
            :related="related" 
            :contract="contract" 
            :otherRelated="otherRelated" 
            :baseTime="baseTime"
            :baseTimeMin="baseTimeMin" 
            :baseTimeMax="baseTimeMax" 
            :otherContract="otherContract"
            :language="language" 
            :otherTech="otherTech" 
            :loading="loading"
            v-show="showModal" 
            @register="register" 
            @close="closeModal"
          >
          </ProjectRegisterModal>
        </CCol>
        <!-- 空白スペース用 -->
        <CCol ></CCol>
      </CRow>
    </ValidationObserver>
  </CCardBody>
</CCard>
</template>

<script>
import axios from 'axios'
import ProjectRegisterModal from './ProjectRegisterModal'
import ConstList from './../ConstList'
export default {
  name: 'ProjectRegister',
  components: {
    ProjectRegisterModal
  },
  data() {
    return {
      showModal: false,
      related:'',
      contract:'',
      otherRelated:'',
      baseTime:'',
      baseTimeMin:'',
      baseTimeMax:'',
      otherContract:'',
      language:'',
      otherTech:'',
      project_name: '',
      start_time: '',
      end_time: '',
      break_start_time: '',
      break_end_time: '',
      company_id: '',
      company_name: '',
      options1: [],
      company_check: [],
      staff_name: '',
      own_staff_id: '',
      own_staff_name: '',
      options2: [],
      user_check: [],
      message: [],
      authorized: false,
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    }
  },

  methods: {
    // プロジェクト管理へ遷移する際の入力値チェック
    valueCheck: function () {
      if ((this.project_name) || (this.start_time) || (this.end_time) || (this.break_start_time) || (this.break_end_time) || (this.company_id) || (this.staff_name) || (this.own_staff_id)
          || (this.related) || (this.contract) || (this.otherRelated) || (this.baseTime) || (this.otherContract) || (this.language) || (this.otherTech)) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({ 
            name: ConstList.ROUTE_PROJECT_LIST
          });
          }
        } else {
          this.$router.push({ 
            name: ConstList.ROUTE_PROJECT_LIST
         });
       }
     },
    // モーダルを表示
    openModal: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      this.company_check.forEach((value, i, array) => {
        if (this.company_id === array[i][ConstList.ID]) {
          this.company_name = array[i][ConstList.NAME]
        }
      })
      this.user_check.forEach((value, i, array) => {
        if (this.own_staff_id === array[i][ConstList.ID]) {
          this.own_staff_name = array[i][ConstList.NAME]
        }
      })
      this.showModal = true
    },
    // 登録内容を送信
    register: function () {
      this.loading = true;
      const start_time_val = this.start_time + ':00'
      const end_time_val = this.end_time + ':00'
      const break_start_time_val = this.break_start_time + ':00'
      const break_end_time_val = this.break_end_time + ':00'
      const jsonList = {
      name: this.project_name,
      start_time: start_time_val,
      end_time: end_time_val,
      break_start_time: break_start_time_val,
      break_end_time: break_end_time_val,
      company_id: this.company_id,
      staff_name: this.staff_name,
      user_id: this.own_staff_id,
      related: this.related,
      contract: this.contract,
      otherRelated: this.otherRelated,
      baseTime: this.baseTime,
      baseTimeMin: this.baseTimeMin,
      baseTimeMax: this.baseTimeMax,
      otherContract: this.otherContract,
      language: this.language,
      otherTech: this.otherTech
      }
      axios
        .post((process.env.VUE_APP_API_ORIGIN) + '/projectRegister', jsonList, {
          headers: {'content-type': 'application/json'}
          })
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.authorized = true
            alert(ConstList.REGISTER_MESSAGE)
            this.$router.push({ 
              name: ConstList.ROUTE_PROJECT_LIST
              });
          } else {
            this.message[0] = response.data
            this.showModal = false
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // モーダルを閉じる
    closeModal: function () {
      this.showModal = false
    },
    // 未然ブロック（半角数字以外）
    digitsOnly(field, e) {
      if (!e.inputType || !e.inputType.startsWith('insert')) return;
      const t = e.target;
      const data = e.data ?? '';
      const start = t.selectionStart ?? t.value.length;
      const end = t.selectionEnd ?? t.value.length;
      const next = t.value.slice(0, start) + data + t.value.slice(end);
      if (!/^\d*$/.test(next)) e.preventDefault();
    },

    // 最終サニタイズ（非数字除去 + 3桁制限）
    sanitizeDigits(field) {
      const cur = String(this[field] ?? '');
      const cleaned = cur.replace(/[^\d]/g, '').slice(0, 3);
      if (cur !== cleaned) this[field] = cleaned;
    },
  },

  // DBから各種情報を取得
  mounted: function () {
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/company')
        .then(response => {
          this.options1 = response.data
          this.company_check = this.options1
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    } {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/manager')
        .then(response => {
          this.options2 = response.data
          this.user_check = this.options2
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
}
</script>

<style scoped>

</style>
